import dynamic from "next/dynamic";

const ClientComponentNoSSR = dynamic(() => import("./ClientComponent"), {
  ssr: false,
  loading: () => <p>Loading...</p>,
});

export default ClientComponentNoSSR;
